import StagePage from '../stage/StagePage';

export default function Round4Page() {
  return <StagePage stage={4} />;
}
